import { FaqLoadingPlaceholder, useAnalyticsPageViewTracker, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { NoConnectionNotification } from 'components/notifications/no-connection/NoConnectionNotification';
import React from 'react';
import { FaqPrivate } from './faq-private/FaqPrivate';
import { useFaq } from './useFaq';
import { useMyProfile } from 'components/my-profile';
import { FaqPublic } from './faq-public/FaqPublic';

export const Faq: React.FC = () => {
    const { cmsContent: faq, isLoading: faqIsLoading, loadingError: faqLoadingErr } = useFaq();
    const { loadingError: myProfileLoadingError, isLoading: myProfileIsLoading } = useMyProfile();
    const { isAuthenticated } = useOidcAuthentication();

    useAnalyticsPageViewTracker('faq', !!faq);

    if (!!faqLoadingErr) return <NoConnectionNotification />;

    return faqIsLoading || myProfileIsLoading ? (
        <FaqLoadingPlaceholder />
    ) : isAuthenticated && !myProfileLoadingError ? (
        <FaqPrivate faqTeaser={faq?.teaser} />
    ) : (
        <FaqPublic faqTeaser={faq?.teaser} />
    );
};
